import { render, staticRenderFns } from "./Sobu.vue?vue&type=template&id=5e56c289&scoped=true"
import script from "./Sobu.vue?vue&type=script&lang=js"
export * from "./Sobu.vue?vue&type=script&lang=js"
import style0 from "./Sobu.vue?vue&type=style&index=0&id=5e56c289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56c289",
  null
  
)

export default component.exports